import React, { Component } from 'react';

import SelectionTab from '../../../../../../components/ZUILib/SelectionTab';
import AddressCelebrityDataContainerWap from './addressCelebrityDataContainerWap';
import AddressName from './addressName';

import commonUtil from '../../../../../../utils/commonUtil';
import _ from 'lodash';
import { connect } from 'react-redux';

const channel = commonUtil.getChannel();

const innerWidth = typeof (window) !== 'undefined' ? window.innerWidth + 'px' : '0px';

@connect(
  store => ({
    eventManagementAddresses: store.deliveryAddress.eventManagementAddresses,
  }),
  {}
)
export default class DeliveryAddressBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addressAssociation: [],
      celebrityAddress: '',
      addressObject: {},
      defaultAddress: []
    };

    this.initialState = [];
    this.addressAssociation = [];
    this.alreadySetTemp = false;
  }

  // * Sets selector to its initial state.
  // * This is determinated when user create event
  resetAllCelebritySelection = () => {
    this.setState({
      ...this.state,
      addressAssociation: this.initialState,
    });
  }

  setAddressAssociation = (index, address, selectedValue) => {
    this.props.personSelectedToUpdateAddress(selectedValue);

    for (let i = 0; i < this.addressAssociation.length; i++) {
      if (selectedValue && (this.addressAssociation[i].ownerId === selectedValue.value)) {
        this.addressAssociation[i].index = index;
        this.addressAssociation[i].ownerId = ' ';
        this.addressAssociation[i].celeName = selectedValue.option;
        document.querySelectorAll('select:not(#select' + address.addressId + ')').forEach((ele) => {
          const e = ele;
          if (ele.value === selectedValue.value) {
            e.selectedIndex = 0;
          }
        });
      }
      if (selectedValue && this.addressAssociation[i].addressId === address.addressId) {
        this.addressAssociation[i].ownerId = selectedValue.value;
      }
      if (!selectedValue && this.addressAssociation[i].addressId === address.addressId) {
        this.addressAssociation[i].ownerId = ' ';
      }
    }

    if (this.addressAssociation.filter(item => item.ownerId === ' ').length) {
      this.props.cancelAddressModified();
    } else {
      this.props.hasAddressModified();
    }

    for (let i = 0; i < this.addressAssociation.length; i++) {
      if (this.addressAssociation[i].ownerId === ' ') {
        this.props.handleShowErrorOnCelebrityNoMapped(true);
        break;
      }
      if (this.addressAssociation[i].ownerId !== ' ') {
        this.props.handleShowErrorOnCelebrityNoMapped(false);
      }
    }

    this.setState({
      ...this.state,
      addressAssociation: this.addressAssociation,
    });

    if (selectedValue) {
      this.props.handleMySelection(index, address, selectedValue);
    }
  }

  openAddressWap = (address) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const box = document.querySelector('.deliveryAddressDetail');
    box.style.display = 'block';
    box.style.opacity = 1;

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('noscroll');

    let winWidth = window.innerWidth;
    box.style.left = winWidth + 'px';
    winWidth -= 1;

    box.style.left = 0 + 'px';
    this.setState({
      ...this.state,
      celebrityAddress: this.addressDataHtmlFn(address),
      addressObject: { ...address },
    });
  }

  closeEditAndNewAddressSection = () => {
    const box = document.querySelector('.deliveryAddressDetail');
    box.style.display = 'none';
    box.style.opacity = 0;

    document.body.classList.remove('noscroll');

    let winWidth = window.innerWidth;
    box.style.left = winWidth + 'px';
    winWidth += 1;

    box.style.left = winWidth + 'px';
  }

  addressDataHtmlFn = (address) => {
    const { address1, exteriorNumber, interiorNumber, building, city, colony, delegationMunicipality, postalCode, state, address2, phoneNumber, particularPhoneCode } = address || '';

    const phoneNumberIsMissingLada = _.isString(phoneNumber) && phoneNumber.length < 10;
    const ladaIsAvailable = _.isString(particularPhoneCode) && particularPhoneCode.length > 0;

    let phoneNumberWithLada = phoneNumber;
    if (phoneNumberIsMissingLada && ladaIsAvailable) {
      phoneNumberWithLada = `${particularPhoneCode}${phoneNumberWithLada}`;
    }

    // Not mandatory, is validated
    const validColony = !colony ? '' : ` ${colony}`;
    const validInteriorNumber = !interiorNumber ? '' : ` Int. ${interiorNumber},`;
    const validBuilding = !building ? '' : ` ${building},`;
    const validCity = !city ? '' : ` ${city},`;
    const validAddress2 = !address2 ? '' : ` ${address2},`;

    const result = commonUtil.sentenceCase(
      `${address1}, Ext. ${exteriorNumber},${validInteriorNumber} ${validBuilding}${validCity}${validColony}, ${delegationMunicipality}, ${postalCode}, ${state},${validAddress2} ${phoneNumberWithLada}`);

    return result;
  };


  HandleDefaultAddresId = (addressid, action) => {
    //it cannot be multiple 
    // only one can be selected 
    //if mutliple address selected disable the buttonn
    //pushing to default address selection

    let newItem = addressid;
    if (action === 'add') {
      this.setState({
        defaultAddress: [...this.state.defaultAddress, newItem]
      }, () => {        
        this.props.handleDefaultSelect(this.state.defaultAddress)
      })
    }
    if (action === "remove") {
      const index = this.state.defaultAddress.indexOf(addressid);       
      const slicedArray = this.state.defaultAddress.filter((_, i) => i !== index);    
      this.setState({
        defaultAddress: slicedArray, // Filter out element at index
      }, () => {         
        this.props.handleDefaultSelect(this.state.defaultAddress)
      });
    }
  }

  render() {
    const props = this.props;
    const deliveryAddress = props.deliveryAddress || {};
    let { addresses } = deliveryAddress || [];
    const eventStatusForSuspended = this.props.eventStatusForSuspended;
    const { lables } = this.props;
    const device = (channel === 'web');
      addresses = addresses.map((address) => {
        return {
          ...address,
          disabletheCheckbox: true, // Ensuring ecommAddressId is set
        };
      });

      let profileAddresses = this.props.eventManagementAddresses || [];

      // if (Array.isArray(profileAddresses) && profileAddresses.length > 0 &&
      //     Array.isArray(savedAddress) && savedAddress.length > 0) {
      //   const savedNicknames = new Set(
      //     savedAddress
      //       .map(addr => addr.nickname) 
      //       .filter(Boolean)
      //   );

      //   profileAddresses = {
      //     ...profileAddresses,
      //     addresses: profileAddresses.addresses.filter(addr =>
      //       savedNicknames.has(addr.nickName)
      //     ),
      //   };
      // }

      if (
        profileAddresses &&
        profileAddresses.length > 0 &&
        addresses &&
        addresses.length > 0
      ) {
        profileAddresses = profileAddresses.map(
          (address) => ({
          ...address,
          defaultAddress: false,
        }),
      );
        profileAddresses = profileAddresses.filter((address) => {
          return !addresses.some((item) => item.ecommAddressId === address.addressId);
        });
        addresses = [...addresses, ...profileAddresses || []];
      }

    const optionsValuesCelebrated = (celebMapList, address) => {
      celebMapList.map((data) => {
        let celebrityId = ' ';
        let celebrityName = ' ';

        return Object.keys(data).filter((key) => {
          const retObj = {};
          if (key !== 'associated') {
            celebrityId = key;
            celebrityName = data[key];
            retObj.value = celebrityId;
            retObj.option = celebrityName;
            retObj.selected = data.associated;

            if (!this.alreadySetTemp
              && !this.addressAssociation.filter(item => item.addressId === address.addressId).length) {
              this.addressAssociation.push({
                addressId: address.addressId,
                ownerId: celebrityId,
                celeName: celebrityName,
              });
            }


            this.celebrityOptions.push(retObj);
            return this.celebrityOptions;
          }
          return retObj;
        });
      });
    };
    let selectedAddresses = [];
    this.props.deliveryAddress.addresses.map((address) => {
        selectedAddresses.push(address.addressId)
      }
    );
    selectedAddresses = [...selectedAddresses,...this.state.defaultAddress]    
    return (
      <div>
        <form
          style={{
            // padding: '0 16px',
            display: device && 'flex',
            // gap: device ? 8 : 0,
            // marginBottom: device ? 40 : 0,
            margin: 8,
            flexWrap: device && 'wrap',
          }}
        >
          {addresses.map((address, index) => {
            this.celebrityOptions = [];
            optionsValuesCelebrated(address.celebMap || [], address);
            if(this.state.defaultAddress.length == props.deliveryAddress.addressesToAdd && !selectedAddresses.includes(address.addressId)){
              return null;
            }
            if (index === (addresses.length - 1) && !this.alreadySetTemp) {
              this.initialState = JSON.parse(JSON.stringify(this.addressAssociation));
              this.alreadySetTemp = true;
            }

            this.props.setCelebrityNameForNewAddress();

            return (<div className='col-sm-12 col-md-6 col-lg-4' key={'add' + address.addressId}
              style={{ display: 'flex', marginBottom: 16, backgroundColor: '#fff', marginRight: device ? 24 : 8, minWidth: device ? '344px' : '100%' }}
            >
              <div
                className={true ? '' : 'deliveryAddressDetail col-sm-4'}
                style={{ 
                  //  backgroundColor: '#fff',
                  // flex: '1'
                 }}
              >
                <AddressCelebrityDataContainerWap
                  closeEditAndNewAddressSection={this.closeEditAndNewAddressSection}
                  addressDataHtmlFn={this.state.celebrityAddress ? '' : this.addressDataHtmlFn}
                  numberOfAddresses={addresses.length}
                  celebrityOptions={this.celebrityOptions}
                  addressObject={address}
                  address={this.state.celebrityAddress}
                  labels={lables}
                  handleDefaultSelect={this.props.handleDefaultSelect}
                  HandleDefaultAddresId ={this.HandleDefaultAddresId}
                  defaultAddress={this.state.defaultAddress}
                  index={index}
                />
              </div>

              {/* { !device &&
                <AddressName
                  nickName={address.nickName}
                  openAddressWap={() => this.openAddressWap(address)}
                  className={'addressName'}
                  addressDescriptionFlag
                />
              } */}

              {/* { this.addressAssociation.length > 0 &&
                <SelectionTab
                  id={'select' + address.addressId}
                  classname={'cSelect'}
                  options={this.celebrityOptions}
                  optionCaption={commonUtil.getLabel(lables.editEventDelivery, 'eventManagement.address.selectPreferences')}
                  optionText={'option'}
                  optionValue={'value'}
                  disable={eventStatusForSuspended && 'disabled'}
                  // value={this.state.addressAssociation.length
                  //   ? this.state.addressAssociation[index].ownerId
                  //   : this.addressAssociation[index].ownerId}
                  value={this.addressAssociation[index].ownerId}
                  handleSelectedOption={selectedValue => this.setAddressAssociation(index, address, selectedValue)}
                  style={{ width: channel === 'web' && addresses.length === 1 ? 352 : '100%' }}
                />
              } */}

            </div>);
          })}
        </form>
      </div>
    );
  }

}